import { fetchApiData } from "../../utils/utils";

let fetchLiveChannelsPromise = null;

export const fetchLiveChannels = async (appInfo) => {
    if (fetchLiveChannelsPromise) {
        return fetchLiveChannelsPromise;
    }
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const api = "schedule/fastchannelsv2";
    const params = {
        timezone: timeZone
    };

    fetchLiveChannelsPromise = fetchApiData(appInfo, api, params).finally(() => {
        setTimeout(() => {
            fetchLiveChannelsPromise = null;
        }, 1000);
    });

    return fetchLiveChannelsPromise;
};

const fastChannelsCache = {};

export const fetchFastChannels = async (appInfo, channelId) => {
    if (!channelId) return null;
    if (fastChannelsCache[channelId]) {
        return fastChannelsCache[channelId];
    }
    const api = `fastchannel/details/${channelId}`;
    fastChannelsCache[channelId] = fetchApiData(appInfo, api).finally(() => {
        setTimeout(() => {
            delete fastChannelsCache[channelId];
        }, 2000);
    });
    return await fastChannelsCache[channelId];
};